export const ICON_SIZE = '150px'

const classes = {
  container: { position: 'fixed', top: '176px', left: `calc(50vw - (${ICON_SIZE} / 2))` },
  iconContainer: { borderRadius: '100px', width: ICON_SIZE, height: ICON_SIZE },
  icon: { fontSize: 'inherit' },
}

export default classes
